module.exports = __webpack_public_path__ + "static/cb1000-776dc21b46383f713a26ffb991234417.png";